import { useEntityAndComponentStore as e } from "../stores/entities-store/useEntityAndComponentStore.js";
import "../stores/index.js";
import { useMemo as t } from "react";
//#region src/lib/hooks/useFilterComponentsOfType.ts
var n = (n) => {
	let r = e((e) => e.components);
	return t(() => r.filter((e) => e.type === n), [r, n]);
};
//#endregion
export { n as useFilterComponentsOfType };
